import React, { useEffect, useState } from "react";
import { FiCheck } from "react-icons/fi";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"

const DisbursementProcessingPage = ({
  setScreen,
  loanAmount,
  customerName,
}) => {
    const [sectionLetterStatus, setSectionLetterStatus] = useState(false);
  const [sectionLetterMessage, setSectionLetterMessage] = useState("");

  const amount = loanAmount
    ? `₹${Number(loanAmount).toLocaleString("en-IN")}`
    : "₹23,800";

      useEffect(() => {
    try {
      const storedResult = sessionStorage.getItem(
        "sectionLetterApiResult"
      );

      if (!storedResult) {
        setSectionLetterStatus(false);
        setSectionLetterMessage(
          "Section Letter verification result not found."
        );
        return;
      }

      const result = JSON.parse(storedResult);

      setSectionLetterStatus(result?.status === true);
      setSectionLetterMessage(
        result?.message || "Section Letter request processed."
      );
    } catch (error) {
      console.error(
        "Section Letter Result Read Error:",
        error
      );

      setSectionLetterStatus(false);
      setSectionLetterMessage(
        "Unable to verify Section Letter status."
      );
    }
  }, []);

  return (
    <section className="fw-screen fw-screen--disbursement fw-fade">

           <div className="fw-brandmain">
          <img 
            src={fundwalelogo} 
            alt="Fundswalle" 
            className="fw-brand__logo1" 
          />
        </div>
  <div>
    <button
    type="button"
    className="fw-btn fw-btn--secondary fw-btn--full"
    onClick={() => setScreen("/apply-new/sectionLetter")}
  >
    Back
  </button>
  </div>
      {/* <div className="fw-disbursement__content">
        <div className="fw-disbursement__success">
          <FiCheck />
        </div>

        <h1>Congratulations!</h1>

        <h2>
          Your loan disbursement is in process.
        </h2>

        <p>
          The loan amount will be credited to your account within 2 hours.
        </p>

        <div className="fw-disbursement__card">
          <div>
            <span>Loan Amount</span>
            <strong>{amount}</strong>
          </div>

          <div>
            <span>Tenure</span>
            <strong>35 Days</strong>
          </div>

          <div>
            <span>Repayment Date</span>
            <strong>2 Jun</strong>
          </div>

          <div>
            <span>Loan Date</span>
            <strong>01/07/2025</strong>
          </div>
        </div>

        {customerName && (
          <p className="fw-disbursement__customer">
            Dear <strong>{customerName}</strong>,
          </p>
        )}
      </div> */}

      {sectionLetterMessage && (
  <p className="fw-disbursement__section-letter-message">
    {sectionLetterMessage}
  </p>
)}
{/* 
      <div className="fw-actions">
        <button
  type="button"
  className="fw-btn fw-btn--primary fw-btn--full"
  onClick={() => setScreen("/apply-new/loanInProgress")}
  disabled={!sectionLetterStatus}
>
  Continue
</button>
      </div> */}
      <div className="fw-actions">


  <button
    type="button"
    className="fw-btn fw-btn--primary fw-btn--full"
    onClick={() => setScreen("/apply-new/loanInProgress")}
    disabled={!sectionLetterStatus}
  >
    Continue
  </button>
</div>
    </section>
  );
};

export default DisbursementProcessingPage;